import React from "react";
import { Form } from "react-bootstrap";
import Names from "./Names";
import SSN from "../form/SSN";

export default function RepresentativeExecutor(props) {
  return (
    <>
      <h5>Representative/Executor</h5>
      <Names
        id="representative"
        onChange={props.onChange}
        state={props.state}
      />
      <Form.Group controlId="representativeSuffixName">
        <Form.Label>Suffix Name (optional)</Form.Label>
        <Form.Control
          as="select"
          onChange={props.onChange}
          value={props.state.representativeSuffixName}
        >
          <option value="">Please Select</option>
          <option value="DDS">DDS</option>
          <option value="MD">MD</option>
          <option value="PhD">PhD</option>
          <option value="JR">JR</option>
          <option value="SR">SR</option>
          <option value="I">I</option>
          <option value="II">II</option>
          <option value="III">III</option>
          <option value="IV">IV</option>
          <option value="V">V</option>
          <option value="VI">VI</option>
        </Form.Control>
      </Form.Group>
      <Form.Group controlId="representativeTitle">
        <Form.Label>Title</Form.Label>
        <Form.Control
          required
          as="select"
          onChange={props.onChange}
          value={props.state.representativeTitle}
        >
          <option value="">Please Select</option>
          <option value="executor">Executor</option>
          <option value="administrator">Administrator</option>
          <option value="personal_representative">
            Personal Representative
          </option>
        </Form.Control>
        <Form.Control.Feedback type="invalid">
          Please select a valid title
        </Form.Control.Feedback>
      </Form.Group>
      <SSN id="representative" state={props.state} onChange={props.onChange} />
    </>
  );
}
